function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import { Col } from './Col';
import { Row } from './Row';
import css from './Grid.sass';

function Grid(props) {
  var children = props.children,
      width = props.width,
      debug = props.debug,
      className = props.className,
      restProps = _objectWithoutProperties(props, ["children", "width", "debug", "className"]);

  var classNames = cx(css.grid, className, width && css["".concat(width, "-width")], debug && css.debug);
  return React.createElement("div", _extends({
    className: classNames
  }, restProps), children);
}

Grid.displayName = 'Grid';
Grid.propTypes = {
  /**
   * Show debug lines
   */
  debug: PropTypes.bool,

  /**
   * Primary content
   */
  children: PropTypes.node,
  width: PropTypes.string,
  className: PropTypes.string
};
Grid.defaultProps = {};
Grid.Row = Row;
Grid.Col = Col;
export { Grid };